import React, { useState, useEffect } from 'react';
import { Col, Container, InputGroup, Row } from 'react-bootstrap';
import AddButton from 'src/Admin/components/User/UserFormNew/components/AddButton';
import FilterModal from 'src/Admin/components/common/filter-modal/FilterModal';
import { SearchSVG } from 'src/Admin/img/GlobalSVG';
import TextInput from 'src/Components/GenericInputText/TextInput';
import List from './List';

const Blob = ({ blobData, dispatch, setBlobData, fetchData }) => {
  const [openBlobModal, setOpenBlobModal] = useState(false);
  const [searchBlogText, setSearchBlogText] = useState('');
  const [blobDataLocal, setBlobDataLocal] = useState({});

  const [openBlobModalForRange, setOpenBlobModalForRange] = useState(false);
  const [searchBlobTextFrom, setSearchBlobTextFrom] = useState('');
  const [searchBlobTextTo, setSearchBlobTextTo] = useState('');

  useEffect(() => {
    setBlobDataLocal(blobData);
  }, []);

  const selectChangeHandler = (e) => {
    const { name, checked, id } = e.target;
    const tempBlob = blobData?.allBlobData?.map((blob) =>
      blob.BlkOfBusId === id
        ? { ...blob, isChecked: true }
        : { ...blob, isChecked: false },
    );
    setBlobDataLocal({
      ...blobDataLocal,
      allBlobData: tempBlob,
      selectedBlobData: tempBlob?.filter((item) => item?.isChecked === true)[0],
    });
    //dispatch(setBlobData({allBlobData: tempBlob, selectedBlobData: tempBlob?.filter(item => item?.isChecked === true)[0]}));
  };

  return (
    <div>
      <div className="heading-container">
        <span className="blob-heading">Block of Business(es)</span>
        <span className="blob-data">
          (
          {blobData?.selectedBlobData?.BlkOfBusId
            ? '1 Block of Business'
            : 'All Block of Businesses'}
          )
        </span>
      </div>
      {!(
        blobData?.selectedBlobData?.BlkOfBusId ||
        blobData?.selectedEmployerData?.oid ||
        blobData?.selectedLocationData?.oid
      ) && (
        <div className="block-of-business-container">
          <div className="flex-1">
            <AddButton
              onClick={() => setOpenBlobModal(true)}
              className={'add-button-active reports-blob-button'}
              label="Select Block of Business by name or ID"
            />
          </div>
          <span className="or-saperator">OR</span>
          <div className="flex-1">
            <AddButton
              onClick={() => setOpenBlobModalForRange(true)}
              className={'add-button-active reports-blob-button'}
              label="Select a Range"
            />
          </div>
        </div>
      )}
      <FilterModal
        showBackButton={false}
        isVisible={openBlobModal || openBlobModalForRange}
        onHide={() => {
          setSearchBlogText('');
          setOpenBlobModal(false);

          setSearchBlobTextFrom('');
          setSearchBlobTextTo('');
          setOpenBlobModalForRange(false);
        }}
        applyFilterHandler={() => {
          if (openBlobModal) {
            dispatch(
              setBlobData({
                blobType: 'single',
                allBlobData: blobDataLocal?.allBlobData,
                selectedBlobData: blobDataLocal?.allBlobData?.filter(
                  (item) => item?.isChecked === true,
                )[0],
              }),
            );
            setOpenBlobModal(false);
          } else if (openBlobModalForRange) {
            dispatch(
              setBlobData({
                blobType: 'range',
                allBlobData: [],
                selectedBlobData: {
                  from: searchBlobTextFrom,
                  to: searchBlobTextTo,
                },
              }),
            );
            setOpenBlobModalForRange(false);
          }
        }}
        showCancel={true}
        titleLabel="Block of Business(es)"
        showApply={true}
        showApplyLabel={openBlobModal ? 'Add Selected' : 'Add Range'}
        customClasses="reports-blob-modal"
      >
        <Container className="mt-3 mb-3">
          {openBlobModal ? (
            <>
              <Row>
                <Col sm={12}>
                  <div>
                    <TextInput
                      parentClassName="mb-2"
                      label="Block of Business"
                      append={
                        <InputGroup.Text>
                          <SearchSVG.SearchSVG className="primary-text-color" />
                        </InputGroup.Text>
                      }
                      inputProps={{
                        type: 'text',
                        placeholder: 'Search by name or BLOB ID',
                        value: searchBlogText,
                        onChange: (e) => {
                          setSearchBlogText(e.target.value);
                        },
                        className: 'border-right-0',
                        autoFocus: false,
                        id: 'filter-broker-input',
                      }}
                    />
                  </div>
                </Col>
              </Row>
              <Row>
                <Col sm={12} className="mb-1">
                  <List
                    //data={blobDataLocal?.allBlobData?.length > 0 ?  blobDataLocal?.allBlobData : blobData?.allBlobData}
                    selectChangeHandler={selectChangeHandler}
                    displayId="BlkOfBusId"
                    displayLabel="BlkOfBusName"
                    labelIdText="BLOB ID"
                    searchString={searchBlogText}
                    modalFor="blob"
                    fetchData={fetchData}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row>
                <Col sm={12} className="mt-3">
                  <div>
                    <TextInput
                      parentClassName="mb-2"
                      label="From Block of Business ID"
                      inputProps={{
                        type: 'text',
                        placeholder: 'Example: 87890',
                        value: searchBlobTextFrom,
                        onChange: (e) => {
                          setSearchBlobTextFrom(e.target.value);
                        },
                        className: 'border-right-0',
                        autoFocus: false,
                        id: 'filter-broker-input',
                      }}
                    />
                  </div>
                </Col>
                <Col sm={12} className="mt-3">
                  <div>
                    <TextInput
                      parentClassName="mb-2"
                      label="To Block of Business ID"
                      inputProps={{
                        type: 'text',
                        placeholder: 'Example: 87890',
                        value: searchBlobTextTo,
                        onChange: (e) => {
                          setSearchBlobTextTo(e.target.value);
                        },
                        className: 'border-right-0',
                        autoFocus: false,
                        id: 'filter-broker-input',
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </>
          )}
        </Container>
      </FilterModal>
    </div>
  );
};

export default Blob;
